<table>
  <thead>
    <tr>
      <th>{{ "business-constraints.feed-type" | translate }}</th>
      <th>{{ "business-constraints.copied" | translate }}</th>
      <th>{{ "business-constraints.available" | translate }}</th>
      <th>{{ "business-constraints.needed" | translate }}</th>
    </tr>
  </thead>
  <tbody>
    @for (error of errors(); track error.name) {
      <tr>
        <td>{{ error.name }}</td>
        <td>{{ error.copy_count }}</td>
        <td>{{ error.available_count }}</td>
        <td>{{ error.needed_count }}</td>
      </tr>
    }
  </tbody>
</table>
